// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".position-view-basic-title {\n  margin-top: 0;\n  margin-bottom: 0.3rem;\n}\n.position-view-basic {\n  color: #72767b;\n  display: flex;\n  flex-wrap: wrap;\n}\n.position-view-basic .position-view-item {\n  width: 33%;\n  margin-bottom: 3rem;\n}\n", ""]);
// Exports
module.exports = exports;
